export type TArrayOfThree = [string, string, string];

/**
 * @link https://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
 */
const getVariant = (value: number, variants: TArrayOfThree) => {
    const abs = Math.abs(value);

    return variants[
        abs % 10 == 1 && abs % 100 != 11
            ? 0
            : abs % 10 >= 2 && abs % 10 <= 4 && (abs % 100 < 10 || abs % 100 >= 20)
                ? 1
                : 2
    ];
};

/**
 * Cклоняет число
 * @param value Число
 * @param variants Варианты слов для склонения
 * @returns Один из вариантов в зависимости от переданного значения {value}
 * @example
 * pluralize(3, ['идея', 'идеи', 'идей']); // идеи
 */
export const pluralize = (value: number, variants: TArrayOfThree) =>
    getVariant(value, variants);

/**
 * Получает функцию для склонения числа
 * @param variants Варианты слов для склонения
 * @example
 * const pluralize = getPluralize(['идея', 'идеи', 'идей']);
 */
export const getPluralize = (variants: TArrayOfThree) => (value: number) =>
    pluralize(value, variants);
